import React from 'react'

const AboutBodewrk = () => {
  return (
    <div className="about-bodewrk">
      <div className="container">
        <div className="about-bodewrk-title text-left">
          <h1 style={{ wordBreak: 'break-word', color: '#4B4D4E', lineHeight: '4rem' }} className="fw-bold">
            SUBSTANCE MEETS <br /> SUSTAINABILITY
          </h1>
        </div>
        <div className="about-bodewrk-description text-right">
          <div className="d-inline-block text-left">
            <p className="fs-36">
              BodeWrk is committed to two <br /> things: authenticity and <br />{' '}
              conscious style.
            </p>
            <p className="fs-36 mt-4">
              We believe that truth outlasts <br /> trends. When you beautify to{' '}
              <br /> express your authentic <br /> personality, your style stays{' '}
              <br /> timeless.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutBodewrk
